import React, { FC } from 'react';
import s from './Player.scss';
import { PlaybackComponentProps } from './Player.types';
import {
  GqlVideoFragment,
  GqlVideoSource,
} from '../../../apollo/generated/graphql';
import { Playable } from './players/Playable';
import { usePlayback } from '../../../hooks';
import { ReactPlayer } from './players/ReactPlayer';
import { Vimeo } from './players/Vimeo/Vimeo';
import { Facebook } from './players/Facebook/Facebook';
import { useStyles } from '@wix/tpa-settings/react';
import stylesParams from '../../../../../stylesParams';

const PlaybackComponents: {
  [key in GqlVideoSource]: FC<PlaybackComponentProps>;
} = {
  [GqlVideoSource.Computer]: Playable,
  [GqlVideoSource.Dropbox]: Playable,
  [GqlVideoSource.GoogleDrive]: Playable,
  [GqlVideoSource.Live]: Playable,
  [GqlVideoSource.Facebook]: Facebook,
  [GqlVideoSource.Vimeo]: Vimeo,
  [GqlVideoSource.Youtube]: ReactPlayer,
};

type Props = {
  video: GqlVideoFragment;
};

const useViewSettings = () => {
  const styles = useStyles();
  return { showTitle: styles.get(stylesParams.showVideoTitle) };
};

export const Player: FC<Props> = ({ video }) => {
  const {
    source,
    title,
    play: {
      entity: { url },
    },
  } = video;
  const { playing, pause } = usePlayback();
  const { showTitle } = useViewSettings();

  const PlaybackComponent = PlaybackComponents[source];

  return url ? (
    <div className={s.root}>
      <PlaybackComponent
        src={url}
        title={showTitle ? title : undefined}
        playing={playing}
        onPlay={() => {}}
        onPause={() => {}}
        onEnd={pause}
      />
    </div>
  ) : null;
};
